import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useLocation, useHistory } from "react-router-dom";
import { getAllRiskRegistor, removeRiskRegistor, riskRegistorUpdate } from "../../actions/riskManagement";
import Pagination from "../Pagination/Pagination";
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import Accordion from '@mui/material/Accordion';
import './risk-register-details.css';
import { API_URL } from "../../utils/constant";
import axios from "axios";
import {
    fetchCustomersforestView
} from "../../actions/customer";

const RiskRegister = () => {
    const { orgId } = useParams();
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const id = useSelector((state) => orgId || state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(1);
    const [isModal, setModal] = useState(1);
    const [editingRiskId, setEditingRiskId] = useState(null);
    const [editingStatusId, setEditingStatusId] = useState(null);
    // Get risk level from URL query params
    const getRiskLevelFromUrl = () => {
        const params = new URLSearchParams(location.search);
        return params.get('risk') || "";
    };

    // Add filter state variables
    const [statusFilter, setStatusFilter] = useState("");
    const [riskLevelFilter, setRiskLevelFilter] = useState(getRiskLevelFromUrl());
    const [assigneeFilter, setAssigneeFilter] = useState("");
    const forestViewList = useSelector(
        (state) => state?.customer?.forestlist?.data?.forestViewClients || []
    );
    const templatesData = useSelector((state) => state?.riskManagement?.riskRegistor?.data);

    useEffect(() => {
        if (id) {
            getAllRiskRegistor(id, dispatch, page, statusFilter, riskLevelFilter, assigneeFilter);
        }
    }, [id, dispatch, page, statusFilter, riskLevelFilter, assigneeFilter]);

    useEffect(() => {
        if (id) {
            fetchCustomersforestView(id, dispatch, 1, '', '', '', '', '');
        }
    }, [id, 1]);


    useEffect(() => {
        setTotalItems(templatesData?.totalRecords)
    }, [templatesData?.totalRecords])

    const removeRiskBtn = (r) => {
        let data = {
            "riskId": r._id
        }
        removeRiskRegistor(id, r?.questionFormId, data, dispatch)
    }

    const handleRiskLevelUpdate = (registerId, newLevel) => {
        let data = {
            orgId: id,
            riskLevel: newLevel,
        }
        riskRegistorUpdate(id, registerId, data, dispatch);
        setEditingRiskId(null);
    };

    const handleStatusUpdate = (registerId, newStatus) => {
        let data = {
            orgId: id,
            status: newStatus.toLowerCase(),
            riskId: registerId
        }
        riskRegistorUpdate(id, registerId, data, dispatch);
        setEditingStatusId(null);
    };

    const handleStatusChange = (registerId, newStatus) => {
        handleStatusUpdate(registerId, newStatus);
    };

    // Function to reset filters
    const resetFilters = () => {
        setStatusFilter("");
        setRiskLevelFilter("");
        setAssigneeFilter("");
    };

    // Update URL when risk level changes
    const handleRiskLevelChange = (value) => {
        setRiskLevelFilter(value);
        setPage(1);
        const params = new URLSearchParams(location.search);
        if (value) {
            params.set('risk', value);
        } else {
            params.delete('risk');
        }
        history.push({
            pathname: location.pathname,
            search: params.toString()
        });
    };

    const downloadFile = async () => {
        try {
            const session = localStorage.getItem("session");
            axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
            const response = await axios.get(
                `${API_URL}/tprm/${id}/question-forms/marked-as-risk/excel`,
                {
                    responseType: "blob",
                }
            );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Risk Register.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            // console.error removed
        }
    };

    return (
        <div className="container-fluid risk-dashboard">
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h1 className="welcome-text">Third Party Risk Register</h1>
                        <nav aria-label="breadcrumb" className="mt-1">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/risk-register" className="welcome-textSmall">Third Party Risk Management</Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Risk Register
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="col-md-6 col-sm-12 text-right hidden-xs d-flex justify-content-end">
                        {templatesData?.riskRegisters?.length === 0 ? null : (
                            <a
                                onClick={(e) => {
                                    e.preventDefault();
                                    downloadFile();
                                }}
                                href="/add-report"
                                className="btn btn-sm btn-primary mr-1 download-report"
                            >
                                Download Excel
                            </a>
                        )}
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="body">
                    <div className="row">
                        <div className="col-sm-3 mb-2">
                            <select
                                className="custom-select custom-select-sm form-control form-control-sm"
                                value={statusFilter}
                                onChange={(e) => {
                                    setStatusFilter(e.target.value);
                                    setPage(1);
                                }}
                            >
                                <option value="">All Status</option>
                                <option value="open">Open</option>
                                <option value="closed">Closed</option>
                            </select>
                        </div>
                        <div className="col-sm-3 mb-2">
                            <select
                                className="custom-select custom-select-sm form-control form-control-sm"
                                value={riskLevelFilter}
                                onChange={(e) => handleRiskLevelChange(e.target.value)}
                            >
                                <option value="">All Risk Levels</option>
                                <option value="high">High</option>
                                <option value="medium">Medium</option>
                                <option value="low">Low</option>
                            </select>
                        </div>
                        <div className="col-sm-3 mb-2">
                            <select
                                className="custom-select custom-select-sm form-control form-control-sm"
                                value={assigneeFilter}
                                onChange={(e) => {
                                    setAssigneeFilter(e.target.value);
                                    setPage(1);
                                }}
                            >
                                <option value="">All Vendors</option>
                                {forestViewList?.map((item, index) => (
                                    <option key={index} value={item?._id}>{item?.orgName}</option> 
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-custom spacing5 mb-0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Risk Title</th>
                                    <th>Vendor</th>
                                    <th>Risk Level</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {templatesData?.riskRegisters?.map((register, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td title={register?.title || "N/A"}
                                            style={{
                                                maxWidth: "250px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }}>{register?.title || "N/A"}</td>
                                        <td>{register?.assigneeOrganisationName || "N/A"}</td>
                                        <td>
                                            {editingRiskId === register?._id ? (
                                                <div className="risk-edit-container">
                                                    <select
                                                        className="risk-level-dropdown"
                                                        defaultValue={register?.riskLevel?.toLowerCase()}
                                                        onChange={(e) => handleRiskLevelUpdate(register?._id, e.target.value)}
                                                    >
                                                        <option value="high">High Risk</option>
                                                        <option value="medium">Medium Risk</option>
                                                        <option value="low">Low Risk</option>
                                                    </select>
                                                    <button
                                                        className="risk-action-button cancel-action"
                                                        onClick={() => setEditingRiskId(null)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="risk-display-wrapper">
                                                    <div className={`risk-indicator ${register?.riskLevel?.toLowerCase() === 'high' ? 'risk-level-high' :
                                                        register?.riskLevel?.toLowerCase() === 'medium' ? 'risk-level-medium' :
                                                            register?.riskLevel?.toLowerCase() === 'low' ? 'risk-level-low' :
                                                                'risk-level-unknown'
                                                        }`}>
                                                        <span className="risk-dot"></span>
                                                        {register?.riskLevel || "N/A"}
                                                    </div>
                                                    <button
                                                        className="risk-edit-trigger"
                                                        onClick={() => setEditingRiskId(register?._id)}
                                                        title="Edit Risk Level"
                                                    >
                                                        <i className="fa fa-edit"></i> Edit
                                                    </button>
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            {editingStatusId === register?._id ? (
                                                <div className="risk-edit-container">
                                                    <select
                                                        className="risk-level-dropdown"
                                                        value={register?.status?.toLowerCase() || "open"}
                                                        onChange={(e) => handleStatusChange(register?._id, e.target.value)}
                                                    >
                                                        <option value="open">Open</option>
                                                        <option value="closed">Closed</option>
                                                    </select>
                                                    <button
                                                        className="risk-action-button cancel-action"
                                                        onClick={() => setEditingStatusId(null)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="risk-display-wrapper">
                                                    <div className={`risk-indicator ${!register?.status || register?.status?.toLowerCase() === 'n/a' ? 'risk-level-unknown' :
                                                        register?.status?.toLowerCase() === 'closed' ? 'risk-level-high' :
                                                        register?.status?.toLowerCase() === 'open' ? 'risk-level-low' :
                                                        register?.status?.toLowerCase() === 'pending' ? 'risk-level-warning' :
                                                        'risk-level-unknown'
                                                        }`}>
                                                        <span className="risk-dot"></span>
                                                        {!register?.status || register?.status?.toLowerCase() === 'n/a' ? 'N/A' :
                                                            register?.status?.toLowerCase() === 'active' ? 'open' :
                                                            register?.status?.toLowerCase() === 'inactive' ? 'closed' :
                                                            register?.status?.toLowerCase() || "N/A"}
                                                    </div>
                                                    <button
                                                        className="risk-edit-trigger"
                                                        onClick={() => {
                                                            setEditingStatusId(register?._id);
                                                            // Auto-save if current status is N/A
                                                            if (!register?.status || register?.status?.toLowerCase() === 'n/a') {
                                                                handleStatusUpdate(register?._id, 'open');
                                                            }
                                                        }}
                                                        title="Edit Status"
                                                    >
                                                        <i className="fa fa-edit"></i> Edit
                                                    </button>
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            <Link
                                                to={`risk-register-details/${register?.questionFormId}/${register?.categoryId}/${register?.questionId}/${register?.assigneeOrganisationId}?riskid=${register?._id}`}
                                                className=" mx-1"
                                            // style={{ backgroundColor: '#433f3f', border: 'none' }}
                                            >
                                                Show Details
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="dataTables_paginate">
                        {totalItems > 0 && (
                            <Pagination
                                className="pagination-bar"
                                currentPage={page}
                                totalCount={totalItems}
                                pageSize={10}
                                onPageChange={(page) => {
                                    setPage(page);
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
            <div
                className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal risk" ? "d-block show" : ""
                    }`}
                style={{ left: '20%', top: '20%' }}
            >
                <div className="modal-dialog" style={{ maxWidth: "400px" }} id="clientModal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Risk Management Principles
                            </h5>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => setModal("")}
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body pricing_page h-auto">
                            <div className="col-xl-12 col-lg-12 col-md-12 p-0">
                                <div className="card mb-2">
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <div className="chatBoxMain mt-2">
                                                <div className="boxAChat" style={{ backgroundColor: '#000', color: '#fff' }}>
                                                    <p className="mb-1">
                                                        B. Is there a third party pentest conducted for the applications anually ?
                                                    </p>
                                                    <p>
                                                        Answer : Now
                                                    </p>
                                                </div>
                                                <div className="boxBChat">
                                                    <p className="recieveMessage">
                                                        No , we have security scan and internal security testing, haven't conducted the pentest by third party.
                                                    </p>
                                                    <p className="recieveTime">
                                                        Amezon - 02/04/2024 12:00
                                                    </p>
                                                </div>
                                                <div className="boxCChat">
                                                    <p className="recieveMessage">
                                                        No , we have security scan and internal security testing, haven't conducted the pentest by third party.
                                                    </p>
                                                    <p className="recieveTime">
                                                        03/04/2024 12:00 -  Brandsek
                                                    </p>
                                                </div>
                                                <div className="boxBChat" style={{ backgroundColor: '#000', color: '#fff' }}>
                                                    <p className="recieveMessage">
                                                        No , we have security scan and internal security testing, haven't conducted the pentest by third party.
                                                    </p>
                                                    <p className="recieveTime">
                                                        Amezon - 02/04/2024 12:00
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="chatSendButton mt-2">
                                                <div className="d-flex w-100">
                                                    <span className="cursor" style={{ color: '#fff' }}>Risk</span>
                                                    <div className="ReplyBox">
                                                        <input
                                                            placeholder="Reply"
                                                            className="form-control border-0 inputUpdateLastest"
                                                            style={{ backgroundColor: '#000', color: '#fff' }}
                                                        />
                                                        <FontAwesomeIcon icon={faPaperPlane} size="lg" className="iconSend" color="#aaa" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RiskRegister;
